import axios from 'axios'

export const getStages = companyId =>
    axios.get(companyId ? `company/stage/get/${companyId}` : 'company/stage/get')
        .then(({ data }) => data)

export const getOnboardingStagesDocuments = companyId =>
    axios.get(companyId ? `company/stage/onboarding-documents/${companyId}` : 'company/stage/onboarding-documents')
        .then(({ data }) => data)